import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetDistinctAthletes from './GetMeetDistinctAthletes';

const MeetDistinctAthletesData = { INITIAL_STATE: { ...BASIC_INITIAL_STATE, arrayAsOptions: [] }, getMeetDistinctAthletes };
export default MeetDistinctAthletesData;